import React, { Component, ErrorInfo, ReactNode } from 'react'

interface Props {
    children: ReactNode
    fallback?: ReactNode
}

interface State {
    hasError: boolean
    error: Error | null
}

function isRefsError(error: Error): boolean {
    const msg = error?.message ?? ''
    return (
        msg.includes('refs') ||
        msg.includes("'refs'") ||
        msg.includes("reading 'refs'") ||
        msg.includes('reading "refs"') ||
        /Cannot read propert(y|ies) of undefined.*refs?/i.test(msg)
    )
}

export class ErrorBoundary extends Component<Props, State> {
    state: State = { hasError: false, error: null }

    static getDerivedStateFromError(error: Error): Partial<State> | null {
        if (isRefsError(error)) return null
        return { hasError: true, error }
    }

    componentDidCatch(error: Error, errorInfo: ErrorInfo) {
        if (isRefsError(error)) return
        console.error('ErrorBoundary:', error, errorInfo)
    }

    render() {
        if (this.state.hasError && this.state.error) {
            if (this.props.fallback) return this.props.fallback
            return (
                <div style={{ padding: 24, fontFamily: 'system-ui' }}>
                    <h2>Something went wrong</h2>
                    <p>{this.state.error.message}</p>
                    <button
                        type="button"
                        onClick={() => (window.location.href = '/login')}
                        style={{
                            marginTop: 16,
                            padding: '8px 16px',
                            cursor: 'pointer',
                        }}
                    >
                        Go to login
                    </button>
                </div>
            )
        }
        return this.props.children
    }
}
